import React from 'react'
import { makeStyles, Tab } from '@material-ui/core'

const useStyle = makeStyles((theme) => ({
  root: {
    ...theme.typography.button,
    borderRadius: 15,
    backgroundColor: theme.palette.grey.lighter,
    margin: theme.spacing(1),
    minWidth: 0,
  },
  wrapper: {
    padding: theme.spacing(0, 1, 0, 1),
    fontSize: '0.95rem',
  },
  selected: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    boxShadow: '0px 8px 30px rgba(0,0,0, 0.1)',
  },
}))

const SectionTab = ({ ariaLabel, label, ...props }) => {
  const classes = useStyle()

  const getAriaLabel = () => {
    return ariaLabel + label
  }

  return (
    <Tab
      aria-label={getAriaLabel()}
      tabIndex="0"
      label={label}
      classes={{
        root: classes.root,
        wrapper: classes.wrapper,
        selected: classes.selected,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
}

export default SectionTab
